import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Canvas from '@antv/f2-react';
import { Chart, Line, Axis, Interval, Tooltip } from '@antv/f2';
import { Empty } from 'antd-mobile';
import BottomNavLayout from "../../../components/BottomNavLayout";
import PubHeader from "../../../components/PubHeader";
import api from "../../../api";


const PowerList = (props) => {
  const params = useParams()
  const { orderId } = params

  const [powers, setPowers] = useState([])

  const refreshPowerList = async () => {
    const resp = await api.userOrderPowerList({ orderId })
    if (resp?.data?.code === 0) {
      setPowers(resp.data.data)
    }
  }

  useEffect(() => {
    refreshPowerList()
  }, [orderId])


  if (!powers || powers.length === 0) {
    return (
      <BottomNavLayout>
        <PubHeader title="功率曲线" />
        <div className="power-list-wrapper">
          <Empty description="没有功率数据" />
        </div>
      </BottomNavLayout>
    )
  }

  return (
    <BottomNavLayout>
      <PubHeader title="功率曲线" />
      <div className="power-list-wrapper">
        <div id="f2-context">
          <Canvas>
            <Chart data={powers}>
              <Axis
                field="d"
                tickCount={5}
                style={{
                  label: { align: 'between' },
                }}
              />
              <Axis field="p" tickCount={8} />
              <Line x="d" y="p" />
              <Tooltip />
            </Chart>
          </Canvas>
        </div>
      </div>
    </BottomNavLayout>
  )
}

export default PowerList